module.exports = __webpack_public_path__ + "static/geometric-bg-01-24ab5b8e9c5eb6e7f9b41b2844901a5c.svg";